import React from "react";
function Notfound() {
  return (
    <div className="flex h-screen overflow-hidden">
      <main>
        <div className="relative flex">
          <p>404</p>
        </div>
      </main>
    </div>
  );
}

export default Notfound;
